import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-calendar-add",
  templateUrl: "./med-icon-calendar-add.component.html",
})
export class MedIconCalendarAddComponent extends SvgMixinComponent {}
